module.exports = __webpack_public_path__ + "img/ic_arrow_select_violet.0dd25b59.svg";